<template>
  <div :class="containerClasses">
    <div v-if="loading" class="d-flex justify-content-center">
      <b-spinner />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: "Loading",

  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    containerClasses: {
      type: String,
      default: "",
    },
  },
};
</script>
